import React from "react";

import Detail from "../Detail/Detail";
import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import shipping from "../../../utils/shipping";
import boxStates from "../../../utils/boxStates";

import env from "../../../utils/env";
import analytics, { events } from "../../../utils/analytics";

const BoxStatus = props => {
  const {
    boxStatusDesc,
    billingCta,
    trackingCta,
    title,
    boxData,
    expired
  } = props;

  const { currentBox } = boxData || {};
  const { boxStatus, shippingCarrier, trackingNumber } = currentBox || {};
  const trackingURL = shipping.getTrackingURL(shippingCarrier, trackingNumber);

  const getDescription = () => {
    if (expired) {
      return boxStatusDesc["EXPIRED"];
    }

    if (boxStatusDesc[boxStatus]) {
      return boxStatusDesc[boxStatus];
    }

    return boxStatusDesc["BOX_STATUS_NO_BOX"];
  };

  const desc = getDescription();
  const trackableStates = [
    boxStates.SHIPPED,
    boxStates.DELIVERED,
    boxStates.PROB_DELIVERED
  ];
  return (
    <Detail icon={"fa-box"} title={title} description={desc}>
      {trackableStates.indexOf(boxStatus) < 0 && !expired && (
        <Button
          className="case-caps"
          type={buttonTypes.LINK.value}
          action={actionTypes.CALL_TO_ACTION.value}
          label={billingCta}
          onClick={() => {
            window.location = `${env.envURL}/upcoming-box-schedule/`;
            analytics.track(events.CLICKED_ELEMENT, {
              element_name: "View Billing / Shipping Schedule",
              option_title: "Box Status"
            });
          }}
        />
      )}
      {trackableStates.indexOf(boxStatus) > -1 && trackingURL && (
        <Button
          className="case-caps"
          type={buttonTypes.LINK.value}
          action={actionTypes.CALL_TO_ACTION.value}
          label={trackingCta}
          onClick={() => {
            window.open(trackingURL, "_blank");
            analytics.track(events.CLICKED_ELEMENT, {
              element_name: "Track Your Order",
              option_title: "Box Status"
            });
          }}
        />
      )}
    </Detail>
  );
};

export default BoxStatus;



// WEBPACK FOOTER //
// ./src/Components/Header/BoxStatus/BoxStatus.js